import { ArticlesInstagramEntity } from 'src/modules/articles/instagram/types';

export enum ArticlesInstagramActions {
  FetchBegin = 'ARTICLES/INSTAGRAM/FETCH/BEGIN',
  FetchSuccess = 'ARTICLES/INSTAGRAM/FETCH/SUCCESS',
  FetchError = 'ARTICLES/INSTAGRAM/FETCH/ERROR',
}

export interface ArticlesInstagramStore {
  isLoading: boolean;
  isLoaded: boolean;
  error: any;
  instagrams: ArticlesInstagramEntity[];
  instagramsCount: number;
  currentPage: number;
}
